import $ from "jquery";
import moment from 'moment-timezone';

const counter = reset => {
  const counterList = $(".counter[data-timestamp], .event-counter[data-timestamp]");

  if (!counterList.length) {
    return;
  }

  const convertSecondsToString = (seconds, count, element) => {
    const m = 60;
    const h = m * 60;
    const d = h * 24;

    let rest = seconds - count;
    let countStr = '';

    const dd = Math.floor(rest / d);
    countStr += `${dd} ${dd === 1 ? 'day' : 'days'}, `;
    rest = rest % d;

    const hh = Math.floor(rest / h);
    countStr += `${hh} ${hh === 1 ? 'hour' : 'hours'}, `;
    rest = rest % h;

    const mm = Math.floor(rest / m);
    const ss = rest % m;
    countStr += `${mm} ${mm === 1 ? 'minute' : 'minutes'}, ${ss} ${ss === 1 ? 'second' : 'seconds'}`;

    element.empty().append(countStr);
  }

  counterList.each(function(i, counter) {
    const element = $(counter);

    if (reset) {
      element.removeClass('counter-initialized');
      element.empty();
      if (element.data('counterInterval')) {
        clearInterval(element.data('counterInterval'));
      }

      element.data('counterInterval', null);
    }

    if (!element.hasClass('counter-initialized')) {
      const timezone =
        element.data('timezone') ||
        (window.themeSettings ? window.themeSettings.timezone : moment.tz.guess());
      const timestamp = parseInt(element.data('timestamp'), 10);
      // Convert timestamp to moment object with the given timezone
      const webinarMoment = moment.tz(timestamp * 1000, timezone);

      // Prepare user timezone data
      const userTz = moment.tz.guess();
      const localWebinarMoment = webinarMoment.clone().tz(userTz);

      // Update date element inside the same block using the user's timezone
      const dateElement = element.closest('.date-block').find('.date');
      if (dateElement.length) {
        dateElement.text(localWebinarMoment.format('DD MMMM YYYY HH:mm'));
      }

      // Get the user's current date and time in their local timezone
      const userNow = moment.tz(moment(), userTz);
      // Calculate the difference in seconds between the webinar date and the current user date
      const seconds = Math.floor(webinarMoment.diff(userNow, 'seconds'));
      let count = 0;

      if (seconds > 0) {
        convertSecondsToString(seconds, count, element);
        element.data('counterInterval', setInterval(function() {
          count++;
          convertSecondsToString(seconds, count, element);
        }, 1000));
      }

      element.addClass('counter-initialized');
    }
  });
}

export default counter;
